module.exports = __webpack_public_path__ + "static/media/calendar.79e72935.png";